export default "__VITE_ASSET__F$$Oft4Z__"